export const wildfire = {
  name: `wildfire`,
  sql: `
    SELECT * FROM solano_wf
    WHERE haz_wf IN ('Very High', 'High', 'Moderate')
    `,
  cartoCSS: `
    #layer {
      polygon-fill: ramp([haz_wf], (#eeff00, #ff4d00,  #ff0000), ("Moderate", "High", "Very High"), =);
      polygon-opacity: 0.3;
      polygon-comp-op: multiply;
    }
    #layer::outline {
        line-width: 0;
        line-color: #FFFFFF;
        line-opacity: 0.5;
    }
  `,
  viz: `
    color: ramp(buckets($haz_wf, ["Very High", "High", "Moderate"]), [opacity(#C81E11, 0.5),opacity(#FFB31A, 0.5), opacity(#FFFF1A, 0.5)])
    strokeWidth: 0
    `
}